import React from 'react';
import PropTypes from 'prop-types';
import { HorseLink } from '../../../shared/links/ProfileLink';

const DescendantsList = ({ data }) => (
    data.length ? (
        <ul className="hp-nicks__descendants">
            {data.map(({ horseUid, styleName }) => (
                <li key={horseUid}>
                    <HorseLink
                        horseUid={horseUid}
                        horseStyleName={styleName}
                        className="ui-link_marked"
                    />
                </li>
            ))}
        </ul>
    ) : <span>No descendants found</span>
);

DescendantsList.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        horseUid: PropTypes.number.isRequired,
        styleName: PropTypes.string.isRequired,
    })),
};

export default DescendantsList;



// WEBPACK FOOTER //
// ./src/js/horse/nicks/components/DescendantsList.jsx